import { render, staticRenderFns } from "./dash1.vue?vue&type=template&id=01159912&"
import script from "./dash1.vue?vue&type=script&lang=js&"
export * from "./dash1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports